<h2 matDialogTitle class="flex">
  <mat-icon class="error-icon">error</mat-icon>
  Fehlerzentrale
</h2>

<mat-dialog-content>
  <p class="count mat-body-medium">{{ errorCenterService.errors().length }} Fehler in dieser Sitzung</p>

  <mat-accordion>
    @for (error of errorCenterService.errors(); track $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="flex">
            <mat-icon class="error-icon">error</mat-icon>
            Fehler
          </mat-panel-title>
          <mat-panel-description>
            <span class="message">{{ message(error) }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <pre class="error-json">{{ error | json }}</pre>
      </mat-expansion-panel>
    } @empty {
      <p class="mat-body-medium">Keine Fehler aufgezeichnet.</p>
    }
  </mat-accordion>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button" mat-button mat-dialog-close>Schließen</button>
</mat-dialog-actions>
